import { useLocation, useNavigate, Outlet, Navigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useEffect, useContext } from "react";
import { GlobalContext } from "../../context";

interface authParams {
  allowedRoles?: string[]
  children?: JSX.Element
}

export default function RequireAuth({ children, allowedRoles }: authParams) {
  const { 
    authRedirect, setAuthRedirect,
  } = useContext(GlobalContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { route } = useAuthenticator((context) => [context.route]);
  const { user } = useAuthenticator((context) => [context.user]);


  useEffect(() => {
    setAuthRedirect(location.pathname)
  }, [])
  
  return (
    user?.getSignInUserSession()?.getIdToken().payload["cognito:groups"].find((role: string) => allowedRoles?.includes(role))
      ? children
      : route === 'authenticated'
        ? <Navigate to="/unauthorised" state={{ from: location }} replace />
        : <Navigate to="/signin" state={{ from: location }} replace />
  )
}